import React from 'react'
import { useEditorStore } from '../state/editor-store'
import type { VoiceOption } from './podcast-editor-provider'

// Sonic 3.0 defaults
// Sonic 3.0 Emotive Defaults
const SONIC_DEFAULT_A = 'c961b81c-a935-4c17-bfb3-ba2239de8c2f' // Kyle
const SONIC_DEFAULT_B = '6ccbfb76-1fc6-48f7-b71d-91ac6298247b' // Tessa

export const useVoicesInitialization = (
  allVoices: Array<{
    id: string
    name?: string | null
    description?: string | null
    gender?: string | null
    language?: string | null
    previewUrl?: string | null
    category?: string
  }> | undefined,
  hostA: string,
  hostB: string
) => {
  const voicesInitializedRef = React.useRef(false)

  React.useEffect(() => {
    const storeApi = useEditorStore.getState()
    if (allVoices && allVoices.length > 0) {
      const options: VoiceOption[] = allVoices.map(v => ({
        id: v.id,
        name: v.name,
        description: v.description ?? undefined,
        gender: v.gender ?? undefined,
        previewUrl: v.previewUrl ?? undefined,
        category: v.category
      }))
      storeApi.setVoices(options)
      // Ensure defaults when podcast not ready yet
      const s = useEditorStore.getState()
      if (!s.hostAVoiceId) s.setHostAVoiceId(hostA)
      if (!s.hostBVoiceId) s.setHostBVoiceId(hostB)
      voicesInitializedRef.current = true
      return
    }
    if (!voicesInitializedRef.current) {
      // Create fallback options
      const options: VoiceOption[] = [
        { id: SONIC_DEFAULT_A, name: 'Kyle (Emotive)', category: 'Emotive' },
        { id: SONIC_DEFAULT_B, name: 'Tessa (Emotive)', category: 'Emotive' }
      ]
      storeApi.setVoices(options)
      const s = useEditorStore.getState()
      if (!s.hostAVoiceId) s.setHostAVoiceId(hostA)
      if (!s.hostBVoiceId) s.setHostBVoiceId(hostB)
      voicesInitializedRef.current = true
    }
  }, [allVoices, hostA, hostB])
}
